import { Skeleton } from './Skeleton';

/** Preserve the result geometry while announcing one concise loading status. */
export function DataSkeleton({ label, layout = 'rows', count = 3 }: { label: string; layout?: 'rows' | 'cards'; count?: number }) {
  return <div role="status" aria-busy="true" className="text-content">
    <p className="sr-only">{label}</p>
    <div aria-hidden="true" className={layout === 'cards' ? 'grid gap-3 lg:grid-cols-2' : 'divide-y divide-line'}>
      {Array.from({ length: count }, (_, index) => <div key={index} className={layout === 'cards' ? 'rounded-card border border-line bg-surface p-4' : 'flex min-h-36 items-start gap-4 py-5'}>
        <div className="w-full min-w-0 space-y-3">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-5 w-2/3 max-w-sm" />
          <Skeleton className="h-3 w-full max-w-lg" />
          <Skeleton className="h-3 w-1/2 max-w-xs" />
        </div>
        {layout === 'rows' ? <Skeleton shape="block" className="h-10 w-24 shrink-0" /> : null}
      </div>)}
    </div>
  </div>;
}
